import React from 'react'

import './index.scss'

const Logo = ({ text, image, imageSelected, href, height }) => (
  <div className="logo">
    {text && <p>{text}</p>}
    <a href={href} target='_blank'>
      <span>
        <img src={image} alt='' style={{ height }} />
        <img src={imageSelected} alt='' style={{ height }} />
      </span>
    </a>
  </div>
)

export default Logo